import React from 'react';
import { Tooltip, TrevorComponent } from '@trevor/ui-components';
import TableRef from '@/util/TableRef';
import ColumnName from '@/util/ColumnName';
import AggregateColumn from '@/util/AggregateColumn';
import { useAppDispatch } from '@/store/hooks';
import styled from 'styled-components';
import { StepValue } from '@/views/QueryBuilder/subcomponents/Steps';
import { PlusButton } from '@/views/QueryBuilder/subcomponents/PlusButton';
import { openDimensionsDropdown } from '@/components/layers/LayerAggregate/layerAggregateSlice';

export type DimensionsReadOnlyModeProps = {
  keys: AggregateColumn[];
  editLayerClicked: F0;
  aliases: Record<string, TableRef>;
  layerId: number;
  pks: ColumnName[];
};
export const DimensionsReadOnlyMode: TrevorComponent<
  DimensionsReadOnlyModeProps
> = ({ keys, aliases, editLayerClicked, layerId, pks }) => {
  const dispatch = useAppDispatch();

  const hasDimensions = keys.length > 0;

  return (
    <DimensionsWrapper onClick={editLayerClicked}>
      <span>{hasDimensions ? 'by' : 'Dimensions'}</span>
      {!hasDimensions ? (
        <PlusButton onClick={() => dispatch(openDimensionsDropdown(true))} />
      ) : (
        keys.map((aggregateColumn, index) => {
          const asColumn = aggregateColumn.columnName();
          const isPk = pks.some((pk) => pk.equals(asColumn));

          const label =
            (isPk && aliases[asColumn.alias()]
              ? aliases[asColumn.alias()].name()
              : aggregateColumn.name()) +
            (aggregateColumn.aggregation()
              ? ` :: ${aggregateColumn.aggregation()}`
              : '');

          return (
            <span key={`groupby_${index}`}>
              <span data-tooltip-id={`groupby_${index}_${layerId}`}>
                <StepValue $type="summarise" onClick={editLayerClicked}>
                  {label}
                </StepValue>
                <Tooltip id={`groupby_${index}_${layerId}`}>
                  {aliases[asColumn.alias()]
                    ? `${aliases[asColumn.alias()].name()}.${asColumn.name()}`
                    : `custom.${asColumn.name()}`}
                </Tooltip>
              </span>
            </span>
          );
        })
      )}
    </DimensionsWrapper>
  );
};

const DimensionsWrapper = styled.div`
  display: flex;
  align-items: center;
`;
